import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {CustomTicketsAdapter} from './custom-tickets.adapters';
import {Ticket, TicketWrapper} from '../model/ticket.model';


@Injectable({
  providedIn: 'root',
})
export class CustomTicketsConnector {
  constructor(protected adapter: CustomTicketsAdapter) {
  }


  loadTicketCategories(): Observable<any> {
    return this.adapter.loadTicketCategories();
  }

  loadTicketCompanyCategories(): Observable<any> {
    return this.adapter.loadTicketCompanyCategories();
  }

  loadTicket(ticketId: string, userId: string): Observable<any> {
    return this.adapter.loadTicket(ticketId, userId);
  }

  addTicket(ticket: Ticket, userId: string): Observable<any> {
    return this.adapter.addTicket(ticket, userId);
  }

  loadTickets(userId: string, pageSize?: number,
              currentPage?: number,
              sort?: string): Observable<TicketWrapper> {
    return this.adapter.loadTickets(userId, pageSize, currentPage, sort);
  }
}
